var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKomatsuLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 34,
    viewBox: "0 0 170 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "komatsu-logo",
    clipPath: "url(#clip0_10915_4150)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.896 0.931335H119.775V8.54491H104.353V17.482H110.045V32.4663H119.795V10.4028H128.895L128.896 0.931335ZM141.858 18.3575C138.71 16.666 135.696 17.0801 135.932 15.4712C136.197 13.6328 139.985 15.0365 142.883 16.7292L145.533 10.3153C141.985 8.25226 139.457 7.77869 137.035 7.66576C134 7.52369 130.851 8.69912 129.156 10.2036C126.419 12.6346 125.778 16.5373 127.42 19.6423C129.451 23.483 133.904 23.477 135.426 24.2213C136.389 24.6949 136.285 25.9274 135.241 26.2553C132.693 27.0615 127.615 23.7963 127.615 23.7963L124.881 30.1555C128.378 32.1773 131.244 33.3613 135.287 33.3613C147.19 33.3613 147.893 21.3398 141.858 18.3575ZM26.0829 8.54612H14.9867L9.79564 20.2093V8.54491H0V32.4675H9.79564V20.3125L15.2624 32.4675H26.4617L20.5263 20.2615L26.0841 8.54491L26.0829 8.54612ZM160.305 8.54612V23.5571H160.291C160.27 24.2578 159.699 24.82 159.001 24.82C158.304 24.82 157.734 24.2578 157.71 23.5571H157.696V8.54491H148.007V23.5122C148.007 30.0645 152.356 33.3928 158.954 33.3928C165.551 33.3928 170 30.192 170 23.5122V8.54491H160.301L160.305 8.54612ZM37.6926 24.157C35.7182 24.157 34.1166 22.525 34.1166 20.5105C34.1166 18.4984 35.7182 16.8676 37.6926 16.8676C39.6683 16.8676 41.2699 18.4984 41.2699 20.5105C41.2699 22.525 39.6671 24.157 37.6926 24.157ZM37.6926 7.62933C30.7141 7.62933 25.0568 13.3972 25.0568 20.5105C25.0568 27.6262 30.7154 33.3916 37.6926 33.3916C44.6748 33.3916 50.3309 27.625 50.3309 20.5105C50.3309 13.3972 44.6736 7.62933 37.6926 7.62933ZM89.2196 8.54369L81.566 30.9958L78.2267 8.54369H69.3746L66.3971 18.1293L63.4149 8.54491H54.5651L51.0073 32.4675H59.806L61.0859 23.3883L63.5521 32.4675H69.2398L71.7072 23.3883L72.9871 32.4675H91.205L94.0914 21.1893L96.9826 32.4675H107.124L98.9667 8.54612H89.2196V8.54369Z",
    fill: "#140A9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10915_4150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 32.7857,
    fill: "white",
    transform: "translate(0 0.607117)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKomatsuLogo);
export default __webpack_public_path__ + "static/media/komatsu-logo.917aea7482e6f6b9755ba2bacbec3229.svg";
export { ForwardRef as ReactComponent };